import React from "react";
import { Box, Typography, TextField, Grid } from "@mui/material";

interface BasicInformationSectionProps {
  formData: {
    title: string;
    shortDescription: string;
    description: string;
  };
  errors: { [key: string]: string };
  onChange: (field: string, value: string) => void;
  onErrorClear: (field: string) => void;
}

const BasicInformationSection: React.FC<BasicInformationSectionProps> = ({
  formData,
  errors,
  onChange,
  onErrorClear,
}) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        variant='h6'
        fontWeight='600'
        gutterBottom
        sx={{
          color: "primary.main",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        📝 Basic Information
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label='Resource Title'
            placeholder='Enter a descriptive title for your resource'
            value={formData.title}
            onChange={(e) => {
              onChange("title", e.target.value);
              if (errors.title) onErrorClear("title");
            }}
            error={!!errors.title}
            helperText={errors.title}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                minHeight: 64,
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label='Short Description'
            placeholder='Brief description for cards and previews'
            value={formData.shortDescription}
            onChange={(e) => {
              onChange("shortDescription", e.target.value);
              if (errors.shortDescription) onErrorClear("shortDescription");
            }}
            error={!!errors.shortDescription}
            helperText={errors.shortDescription}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                minHeight: 64,
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={4}
            label='Full Description'
            placeholder='Provide a detailed description of this resource'
            value={formData.description}
            onChange={(e) => {
              onChange("description", e.target.value);
              if (errors.description) onErrorClear("description");
            }}
            error={!!errors.description}
            helperText={errors.description}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                minHeight: 140,
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BasicInformationSection;
